import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Countdown, Button, TrustBar } from './Shared';
const SAVINGS = [['Merienda envasada comprada', '$60 a $120 UYU'], ['Compra de apuro en el camino', '$80 a $150 UYU'], ['Merienda planificada con el MEGAPACK', '$15 a $35 UYU'], ['Ahorro diario estimado', '$45 a $85 UYU'], ['Ahorro mensual estimado', '$1.300 a $1.900 UYU'], ['Ahorro anual estimado', '$13.000 a $19.000 UYU']];
export function Precios() {
  return <>
      <section className="border-y border-orange-100 bg-orange-50 px-4 py-14 text-center" data-id="element-142" data-mp="1dk7tqcyl4uii">
        <div className="mx-auto max-w-3xl" data-id="element-143" data-mp="zk6qiquulazv">
          <span className="inline-flex items-center gap-2 rounded-full bg-red-100 px-4 py-1.5 text-sm font-bold text-red-700" data-id="element-144" data-mp="zjevbh55xfa4">
            <span className="h-2 w-2 animate-pulse rounded-full bg-red-600" data-id="element-145" data-mp="14kuibeqwhvv5" />{' '}
            Precio de lanzamiento · termina pronto
          </span>
          <h2 className="mt-5 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-146" data-mp="3paa39t3fuqcv">
            ⏰ PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>
          <div className="mt-3" data-id="element-147" data-mp="154kammutukte">
            <Countdown data-id="element-148" data-mp="104fvp19khy5a" />
          </div>
          <p className="mt-4 text-lg font-medium text-brand-text" data-id="element-149" data-mp="105h5l2eukelf">
            Después vuelve a su precio real de $590 UYU. No vuelve esta oferta.
          </p>
        </div>
      </section>

      <section className="bg-brand-base px-4 py-20" data-id="element-150" data-mp="1a096af3q7hkf">
        <div className="mx-auto max-w-5xl" data-id="element-151" data-mp="1o13fgzyllmk5">
          <header className="text-center" data-id="element-152" data-mp="1o00qixku5u6v">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-153" data-mp="1j2s58o4e5a1e">
              La matemática del ahorro
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-154" data-mp="1xqmyc5mb9gf0">
              Lo que cuesta improvisar vs. planificar
            </h2>
          </header>
          <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-2xl border border-brand-sky bg-white shadow-sm" data-id="element-155" data-mp="26sw9mxpeldtg">
            <div className="grid grid-cols-[1fr_auto] bg-brand-deep px-5 py-3 text-sm font-bold text-white" data-id="element-156" data-mp="22oeq8zmyh2j7">
              <span data-id="element-157" data-mp="29ruzfe6zhtyb">Situación</span>
              <span data-id="element-158" data-mp="2es96ou0rgzva">Costo estimado</span>
            </div>
            {SAVINGS.map(([label, value], index) => <div key={label} className={`grid grid-cols-[1fr_auto] gap-4 px-5 py-4 text-sm font-medium md:text-base ${index % 2 === 0 ? 'bg-white' : 'bg-brand-lightBlue'} ${index >= 3 ? 'text-brand-green' : 'text-brand-text'}`} data-id="element-159" data-mp="2jqua12bb7zny" data-mpi={index}>
                <span data-id="element-160" data-mp="2xiqymwdrrrfl">{label}</span>
                <strong data-id="element-161" data-mp="2xhpbhtjhbehi">{value}</strong>
              </div>)}
          </div>
          <article className="mx-auto mt-10 max-w-3xl rounded-3xl border border-brand-sky bg-white p-7 text-center shadow-sm" data-id="element-162" data-mp="32jogt8ys4lh3">
            <p className="text-sm font-bold uppercase tracking-wider text-brand-gray" data-id="element-163" data-mp="37gokjd85pc51">
              Inversión en el MEGAPACK completo
            </p>
            <p className="mt-2 font-display text-5xl font-bold text-brand-orange" data-id="element-164" data-mp="1d2ndi52gditv">
              $390 <span className="text-xl" data-id="element-165" data-mp="3qe8b474wcrzs">UYU</span>
            </p>
            <div className="my-7 border-t border-slate-100" data-id="element-166" data-mp="3qft6u02y6gz8" />
            <p className="font-display text-xl font-bold text-brand-deep" data-id="element-167" data-mp="3lm6r1z1hlwz7">
              Con una semana de meriendas planificadas:
            </p>
            <p className="mt-3 text-lg text-brand-text" data-id="element-168" data-mp="3hj0r194yx216">
              5 días × $80 UYU de ahorro = <strong data-id="element-169" data-mp="3ck7b7a27kyxu">$400 UYU</strong>
            </p>
            <p className="mt-6 flex items-center justify-center gap-2 font-bold text-brand-green" data-id="element-170" data-mp="d658knckn0lq">
              <CheckCircle2Icon className="h-6 w-6" data-id="element-171" data-mp="96mnnrkr2piw" /> Recuperaste la inversión
              en la primera semana.
            </p>
            <p className="mt-2 font-medium text-brand-text" data-id="element-172" data-mp="44nkoisx9umh">
              A partir de la segunda semana, todo es ahorro puro. De por vida.
            </p>
          </article>
        </div>
      </section>

      <section id="precios" className="scroll-mt-10 bg-white px-4 py-20" data-id="element-173" data-mp="2oy0p5jvy9iom">
        <div className="mx-auto max-w-xl" data-id="element-174" data-mp="2jwuzjuxl6bjb">
          <header className="text-center" data-id="element-175" data-mp="2jzz6h02frldo">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-176" data-mp="bnvgn7bvr9a6">
              Elegí Meriendas que Acompañan
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-5xl" data-id="element-177" data-mp="2oi6sdjugiox">
              Un MEGAPACK para{' '}
              <span className="text-brand-orange" data-id="element-178" data-mp="7oecch86wi6l">todas las mañanas.</span>
            </h2>
            <p className="mt-4 text-lg font-medium leading-relaxed text-brand-text" data-id="element-179" data-mp="vcntv6ydejrx">
              Incluye los 6 tomos completos · 3 bonos estratégicos · 60 ideas
              listas y el planificador de 4 semanas.
            </p>
          </header>
          <article className="relative mt-12 overflow-hidden rounded-3xl border-2 border-brand-orange bg-orange-50 p-6 shadow-[0_12px_30px_rgba(245,124,0,0.18)] md:p-8" data-id="element-180" data-mp="lgu5mqbah1ub">
            <span className="absolute right-5 top-0 rounded-b-xl bg-brand-orange px-4 py-1.5 text-xs font-bold text-white" data-id="element-181" data-mp="3647773h6j1ga">
              LA OPCIÓN MÁS INTELIGENTE
            </span>
            <div className="pt-6" data-id="element-182" data-mp="33jhil7bj68i0">
              <div className="flex items-start gap-4" data-id="element-183" data-mp="33ippc35eomuw">
                <span className="text-4xl" data-id="element-184" data-mp="2ym8wwwr6bmc0">🍎</span>
                <div data-id="element-185" data-mp="2ynk5d9vkdi9g">
                  <h3 className="font-display text-2xl font-bold text-brand-deep" data-id="element-186" data-mp="3ckywqk5do042">
                    MEGAPACK COMPLETO
                  </h3>
                  <p className="mt-1 font-medium text-brand-text" data-id="element-187" data-mp="37nfhpi0uvjb2">
                    6 tomos + 3 bonos + 60 meriendas + planificador de 4 semanas
                  </p>
                </div>
              </div>
              <span className="mt-5 inline-block rounded-full border border-green-200 bg-brand-greenSoft px-3 py-1 text-xs font-bold text-brand-green" data-id="element-188" data-mp="2fwj2iarbp2km">
                🟢 AHORRÁS $480 UYU
              </span>
              <div className="mt-6 flex items-end gap-3" data-id="element-189" data-mp="2oubizi8s6g9l">
                <span className="pb-1 text-lg font-semibold text-brand-gray line-through" data-id="element-190" data-mp="215abpybopb5w">
                  $870 UYU
                </span>
                <span className="font-display text-5xl font-bold text-brand-deep" data-id="element-191" data-mp="1w4wb31cex3hw">
                  $390
                </span>
                <span className="pb-2 text-sm font-bold text-brand-gray" data-id="element-192" data-mp="52nnjz9nm9da">
                  UYU
                </span>
              </div>
            </div>
            <div className="mt-7" data-id="element-193" data-mp="9u5o4m7rm7xq">
              <Button className="py-5" data-id="element-194" data-mp="esqp4nuucvn8">🌟 LO QUIERO AHORA — $390 UYU</Button>
            </div>
            <div className="mt-6" data-id="element-195" data-mp="eujpjlev2jms">
              <TrustBar data-id="element-196" data-mp="3db5rxaumvwfo" />
            </div>
          </article>
          <p className="mt-5 text-center text-sm font-semibold text-brand-orange" data-id="element-197" data-mp="3dcp4orh2zpcp">
            ⚡ El precio actual es exclusivo para los primeros 500 compradores.
          </p>
          <div className="mt-16 rounded-3xl border border-brand-sky bg-brand-lightBlue p-7 shadow-sm" data-id="element-198" data-mp="3n78sic9u7n0i">
            <h3 className="text-center font-display text-2xl font-bold text-brand-deep" data-id="element-199" data-mp="3r811d4esrpw9">
              Por qué el MEGAPACK completo es la decisión más inteligente
            </h3>
            <div className="mt-7 grid gap-5 md:grid-cols-2" data-id="element-200" data-mp="16ibnatlx484m">
              <div className="rounded-xl border border-slate-200 bg-white p-5" data-id="element-201" data-mp="2r2gqzzervo9v">
                <p className="font-bold text-brand-deep" data-id="element-202" data-mp="2n0byx53z2zpc">
                  SI COMPRÁS SOLO UN TOMO ·
                </p>
                <p className="mt-2 text-sm leading-relaxed text-brand-text" data-id="element-203" data-mp="2i93u6mdl82ii">
                  Tenés una parte del sistema. Resolvés una situación puntual.
                  Pero el lunes siguiente la pregunta puede volver.
                </p>
              </div>
              <div className="rounded-xl border border-brand-sky bg-white p-5" data-id="element-204" data-mp="28935ekwy8u6x">
                <p className="font-bold text-brand-blue" data-id="element-205" data-mp="23b1n427ckywi">
                  SI COMPRÁS EL MEGAPACK COMPLETO POR $390 UYU ·
                </p>
                <p className="mt-2 text-sm leading-relaxed text-brand-text" data-id="element-206" data-mp="1uby4t0g08nj2">
                  Tenés todo integrado para resolver cualquier mañana, recuperás
                  la inversión en la primera semana y a partir de la segunda
                  todo es ahorro puro.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}